import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const OSModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Introduction to OS: Functionality of OS - OS design issues', path: '/os-m1-s1' },
      { name: 'Structuring methods (monolithic, layered, modular, micro-kernel models)', path: '/os-m1-s2' },
      { name: 'Abstractions, processes, resources - Influence of security, networking, and multimedia', path: '/os-m1-s3' }
    ],
    'Module 2': [
      { name: 'System calls, System/Application Call Interface', path: '/os-m2-s1' },
      { name: 'Protection: User/Kernel modes - Interrupts', path: '/os-m2-s2' },
      { name: 'Processes - Structures (Process Control Block, Ready List etc.), Process creation, management in Unix', path: '/os-m2-s3' },
      { name: 'Threads: User level, kernel level threads and thread models', path: '/os-m2-s4' }
    ],
    'Module 3': [
      { name: 'Processes Scheduling - CPU Scheduling: Pre-emptive, non-pre-emptive - Multiprocessor scheduling', path: '/os-m3-s1' },
      { name: 'Deadlocks - Resource allocation and management - Deadlock handling mechanisms: prevention, avoidance, detection, recovery.', path: '/os-m3-s2' }
    ],
    'Module 4': [
      { name: 'Inter-process communication, Synchronization - Implementing synchronization primitives (Peterson’s solution, Bakery algorithm, synchronization hardware)', path: '/os-m4-s1' },
      { name: 'Semaphores – Classical synchronization problems', path: '/os-m4-s2' },
      { name: 'Monitors: Solution to Dining Philosophers problem', path: '/os-m4-s3' }
    ],
    'Module 5': [
      { name: 'Main memory management, Memory allocation strategies', path: '/os-m5-s1' },
      { name: 'Virtual memory: Hardware support for virtual memory (caching, TLB) – Paging – Segmentation', path: '/os-m5-s2' },
      { name: 'Demand Paging - Page Faults - Page Replacement - Thrashing - Working Set', path: '/os-m5-s3' }
    ],
    'Module 6': [
      { name: 'Virtual Machines - Virtualization (Hardware/Software, Server, Service, Network - Hypervisors - Container virtualization - Cost of virtualization)', path: '/os-m6-s1' },
      { name: 'File system implementation (directory implementation, file allocation methods) - File system recovery - Journaling - Soft updates - Log-structured file system - Distributed file system.', path: '/os-m6-s2' }
    ],
    'Module 7': [
      { name: 'Disk structure and attachment – Disk scheduling algorithms (seek time, rotational latency based)', path: '/os-m7-s1' },
      { name: 'System threats and security – Policy vs mechanism - Access vs authentication - System protection: Access matrix – Capability based systems', path: '/os-m7-s2' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Operating Systems</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-OSModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OSModules;
